<template>
  <div class="comments-list flex">
    <div class="comment">
      <div
        class="profile-image"
        v-if="comment.user.image !== 'profiles/placeholder.png'"
      >
        <img
          :src="`https://hyreads.com/${comment.user.image}`"
          alt=""
          style="width: 80; height: 100%"
        />
      </div>
      <div v-else>
        <avatar
          :username="comment.user.name"
          style="width: 2rem; height: 2rem"
        ></avatar>
      </div>
    </div>
    <div class="comment-body">
      <div class="comment-body">
        <p>
          <b> &nbsp;&nbsp;{{ comment.user.name }}</b>
          {{ comment.content }}<span></span>
        </p>
        <a
          class="ml-3"
          style="cursor: pointer"
          @click="$store.state.replyToComment = comment"
          v-if="$store.state.replyToComment == false"
          ><i class="fa fa-reply fa-sm" style="cursor: pointer"></i> Reply</a
        >
        <a
          class="ml-3"
          style="cursor: pointer"
          @click="$store.state.replyToComment = !comment"
          v-else
          ><i class="fa fa-reply fa-sm" style="cursor: pointer"></i> Reply</a
        >
        <comment-form
          v-if="$store.state.replyToComment == comment"
        ></comment-form>
        <comment-list
          v-if="collection"
          v-bind:comments="collection"
          v-bind:collection="collection"
        ></comment-list>
        <!-- {{ collection }} -->
      </div>
    </div>
  </div>
</template>

<script>
import CommentList from "./CommentList.vue";
import CommentForm from "./CommentForm.vue";
import Avatar from "../Avatar";
import { events } from "../../events";
export default {
  components: {
    CommentList,
    CommentForm,
    Avatar,
  },
  props: ["comment", "collection"],
  mounted() {
    var self = this;

    window.HyreadsEvents.on(events.COMMENT_REPLY, (data) => {
      if (self.comment.id == data.data.parent) {
        self.comment.children.unshift(data.data);
      }
      console.log("comments", data.data);
      this.$store.state.replyToComment = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.comments-list {
  margin-top: 0.7rem;
  border-left: dotted 1px;
}

.comment .profile-image {
  width: 30px;
  height: 30px;
}
.comment .comment-body {
  background: rgb(241, 241, 241);
  padding: 0.5rem;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}
</style>
